import { Button } from '@/components/shared/atoms/Button'
import { useSaveButtonColor } from '@/stores/saveButtonColor'
import { classNames } from '@/utils/classNames'

interface CreateCollectionCTAProps {
    onClick: () => void
    text?: string
    className?: string
}

/**
 * Sticky bottom CTA button for creating a new collection.
 * Used in mobile bottom sheets for both Products and Looks flows.
 * Integrates with saveButtonColor store for dynamic theming.
 */
export function CreateCollectionCTA({
    onClick,
    text = 'Create new collection',
    className,
}: CreateCollectionCTAProps) {
    const { color: saveButtonColor } = useSaveButtonColor()

    return (
        <div className="sticky bottom-0 shrink-0 border-t border-gray-200 bg-white px-2 pt-3 pb-4 pb-safe">
            <Button
                className={classNames(
                    'w-full rounded-xl py-3 text-sm font-medium text-white',
                    className
                )}
                style={{ backgroundColor: saveButtonColor }}
                onClick={onClick}
            >
                {text}
            </Button>
        </div>
    )
}

